import Model from './model.js'
import Contact from './contact.js'

export default class Deal extends Model {
	static _routeKey = 'deal'
	// static _routes = {
	// 	index: '/deals',
	// 	create: '/deal',
	// 	view: '/deal/:id',
	// 	edit: '/deal/:id',
	// 	delete: '/deal/:id'
	// }

	static _attributes = {
		category_id: null,
		name: '',
		summary: '',
		quoted: '',
		profit: '',
		temperature: 50,
		status: null,
		state: null,
		margin: function () {
			if (this.quoted == '' || this.profit == '') {
				return ''
			}

			return Number((100 / parseFloat(this.quoted)) * parseFloat(this.profit)).toFixed(0)
		},
	}

	tailIgnore = ['status_updated_at', 'contact_id']

	tail = {
		category_id: () => ['category', this.category_id],
		quoted: () => ['Revenue', this.quoted == null ? null : this.vue.$help.dp(this.quoted, 0)],
		profit: () => ['Profit', this.profit == null ? null : this.vue.$help.dp(this.profit, 0)],
		status: () => ['stage', this.$help.capitalizeFirstLetter(this.status)],
		won_at: () => ['won at', this.vue.$help.formatDateTime(this.won_at, { date: true, time: true })],
		lost_at: () => ['lost at', this.vue.$help.formatDateTime(this.lost_at, { date: true, time: true })],
		name: () => ['title', this.name],
		// extra_keys: {
		//     margin: () => ['Margin (%)', this.profit != null && this.quoted != null ? this.getMargin() : null],
		// },
		createdDescription: () => {
			return (this.name != null && this.name != '' ? this.name : this.category_id) + ' was created'
		},
	}

	_logIcon() {
		return 'IconDealDraft'
	}

	_constructor() {
		if (this.contact != null) {
			this.contact = new Contact(this.contact)
		}
	}

	getName() {
		return this.name != null && this.name != '' ? this.name : this.category.name
	}

	// this.vue.$help.capitalizeFirstLetter(

	getTemperature() {
		switch (true) {
			case this.status == 'lost':
				return ['Lost', 'bg-grey-800 border-grey-800 text-grey-800']
				break
			case this.temperature == 20:
				return ['Cold', 'bg-blue-600 border-blue-600 text-blue-600']
				break
			case this.temperature == 50:
				return ['Warm', 'bg-red-600 border-red-600 text-red-600']
				break
			case this.temperature == 80:
				return ['Hot', 'bg-red-700 border-red-700 text-red-700']
				break
		}
	}

	getStatusColour() {
		if (this.lost != null) {
			return '#939393'
		}

		if (this.won_at != null || this.status == 0) {
			return '#00B885'
		}

		if (this.setting_status != null) {
			return this.setting_status.color
		}
	}

	getStatus(id = false) {
		if (this.lost != null) {
			return 'lost'
		}

		if (this.won_at != null) {
			return id ? 0 : 'won'
		}

		if (this.setting_status != null) {
			return id ? this.setting_status.id : this.setting_status.name
		}
	}

	getMargin() {
		return Number((100 / parseFloat(this.quoted)) * parseFloat(this.profit)).toFixed(0) + '%'
	}

	view() {
		return '/deal/' + this.id
	}

	edit() {
		this.vue.$event.$emit('modal-open', {
			view: 'Deal',
			editingModel: this,
			options: {
				task: this,
			},
		})
	}

	timeline(user) {
		let t = this._timeline(user)

		return {
			title: t.user + ' created a new deal',
			description: this.getName(),
			created_at: this.created_at,
			icon: 'IconDealCircle',
			breakdown: {
				'Deal category': this.category.name,
				'Deal title': this.name,
				'Revenue (£)': this.vue.$help.dp(this.quoted, 0),
				'Profit (£)': this.vue.$help.dp(this.profit, 0),
				'Margin (%)': this.getMargin(),
				'Deal stage': {
					type: 'dealStatus',
					text: this.vue.$help.capitalizeFirstLetter(this.setting_status.name),
					circleStyle: this.getStatusColour(),
					deal: this,
				},
				'Deal summary': this.summary,
			},
			options: {
				Edit: () => this.edit(),
			},
		}
	}

	updateStatus(status) {
		if (status == 'lost') {
			this.vue.$event.$emit('modal-open', {
				view: 'Lost',
				modelType: 103,
				options: {
					data: [this.id],
					dataName: 'deal',
				},
			})

			return false
		}

		this.vue.$axios
			.post('/deal/' + this.id, {
				status: status,
				_method: 'PUT',
			})
			.then((res) => {
				console.log('res', res)
				// this._updateFromRes(res.deal)
				this.status = res.deal.status
				this.won_at = res.deal.won_at
				this.lost = res.deal.lost
				this.contact = new Contact(this.contact)

				if (this.won_at != null) {
					// this.vue.$event.$emit('deal-won', res.deal)
					this.vue.$help.won(this.vue)
				}

				this.vue.$event.$emit('modal-form-completed')
				this.vue.$event.$emit('timeline-refresh')
			})
	}
}
